<template>
  <RunningCard>
    <template #header>
      <HubRunningCancel v-if="isCancel" :orderInfo="orderInfo" />
      <HubRunningPendding v-else-if="isPendding" :orderInfo="orderInfo" />
      <HubRunningWaiting v-else-if="isWaiting" :orderInfo="orderInfo" />
      <HubRunningDispatching v-else-if="isDispatching" :orderInfo="orderInfo" />
    </template>
    <template #content>
      <RunningSummary :orderInfo="orderInfo" />
    </template>
  </RunningCard>
</template>

<script>
import RunningCard from "./RunningCard.vue";
import HubRunningCancel from "./HubRunningCancel.vue";
import HubRunningPendding from "./HubRunningPendding.vue";
import HubRunningWaiting from "./HubRunningWaiting.vue";
import HubRunningDispatching from "./HubRunningDispatching.vue";
import RunningSummary from "./RunningSummary.vue";

export default {
  components: {
    RunningCard,
    HubRunningCancel,
    HubRunningPendding,
    HubRunningWaiting,
    HubRunningDispatching,
    RunningSummary,
  },
  props: {
    orderInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    isDispatching() {
      const { isDispatching } = this.orderInfo || {};
      return isDispatching;
    },
    isWaiting() {
      const { isWaiting } = this.orderInfo || {};
      return isWaiting;
    },
    isPendding() {
      const { isPendding } = this.orderInfo || {};
      return isPendding;
    },
    isCancel() {
      const { isCancel } = this.orderInfo || {};
      return isCancel;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.hub-summary {
  font-size: 14px;
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .middle {
    display: flex;
    align-items: center;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
  }
  .col {
    display: flex;
    flex-direction: column;
  }
  .top {
    margin-top: 8px;
  }
  .left {
    margin-left: 5px;
  }
  .end {
    align-items: flex-end;
  }
  .spine {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(23, 146, 255, 0.22);
    margin-right: 5px;
    border-radius: 50%;
    border-right-color: rgba(23, 146, 255, 1);
    animation: rotate linear 2s infinite;
  }

  .notice {
    width: 100%;
    background: #f7f7f7;
    border-radius: 3px;
    padding: 8px 11px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
</style>
